import React, { useContext, useState, useEffect } from "react";
import { useIntl, FormattedMessage, injectIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { FlitServiceContext } from "../../services/flitService";
import Moment from 'react-moment';
import moment from "moment-timezone";
import { makeStyles, lighten, withStyles, useTheme } from "@material-ui/core/styles";
import { red } from "@material-ui/core/colors";
import { Card, CardHeaderToolbar, CardBody, CardHeader } from "../../../_metronic/_partials/controls/Card";
import { useSubheader } from "../../../_metronic/layout/_core/MetronicSubheader";
import {
  Paper, Table, TableHead, TableRow, TableCell, TableBody, Checkbox, Toolbar, Typography,
  Tooltip, IconButton, TableSortLabel, TablePagination, Switch, FormControlLabel, LinearProgress, TableFooter, Tabs, Tab,
} from "@material-ui/core";
import { Form, ToggleButton, ToggleButtonGroup, Row, Col, DropdownButton, Dropdown, Button,ButtonGroup, Modal } from "react-bootstrap";
//import { ConsolScheduleDialog } from "./ConsolScheduleDialog";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import cf from '../../services/codeformatter';
import { ROLES, FREIGHT_MODE, CONSOL_STATUS, MEASUREMENT_SYSTEM_TYPE, INCOTERMS, PACKAGE_TYPE } from "../../services/flitEnum";
import { ReactComponent as CargoShipIcon } from "../../assets/icons/cargo-ship.svg";
import { ReactComponent as AirplaneIcon } from "../../assets/icons/airplane.svg";
import { getModeCssClasses, getScheduleStatusCssClasses,getConsolStatusCssClasses, isValidDate } from './ConsolUIHelper';
import { getStatusCssClasses } from "../Shipment/ShipmentUIHelper";
import { AvailableScheduleDialog } from "./AvailableScheduleDialog";
import cargoImage from "../../assets/images/cargo.png";
import ShipmentDetail from "../Shipment/shipment-detail/ShipmentDetail";
import ShipmentDetailDetail from "../Shipment/shipment-detail/ShipmentDetailDetail";
import ConsolRouteSummary from "./route-summary/ConsolRouteSummary";
import RouteDetail from "../Shipment/route/RouteDetail";
import { sortRoutes } from "../Shipment/route/RouteUIHelper";
import FilterListIcon from "@material-ui/icons/FilterList";
import clsx from 'clsx';
import { from, Observable, forkJoin } from 'rxjs';
import ReactDataSheet from "react-datasheet";
import * as Yup from "yup";
import { Formik } from "formik";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import ConsolScheduleInvoices from "./consol-schedule-invoices/ConsolScheduleInvoices";
import { FileInvoiceDialog } from "../Invoice/invoice-create/FileInvoiceDialog";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import RouteSummary from "../Shipment/route/RouteSummary";
import { NewConsolOrderDialog } from "./NewConsolOrderDialog";

function desc(a, b, orderBy) {
  orderBy = orderBy == 'submittedOn' ? 'id' : orderBy;
  if (b[orderBy] < a[orderBy]) {
      return -1;
  }
  if (b[orderBy] > a[orderBy]) {
      return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
const headRows = [
  { id: 'status', align: 'center', disablePadding: false, label: "STATUS", sortable: true },
  { id: 'businessEntity', align: 'center', disablePadding: false, label: "BUSINESS_ENTITY", sortable: false },
  { id: 'submittedOn', align: 'center', disablePadding: false, label: "SUBMITTED_ON", sortable: true },
  { id: 'originDropOffOn', align: 'center', disablePadding: false, label: "ORIGIN_DROPOFF_ON", sortable: true },
  { id: 'houseBillNo', align: 'center', disablePadding: true, label: 'HBL', sortable:false },
  { id: 'incoterms', align: 'center', disablePadding: true, label: 'INCOTERMS', sortable:false },
  { id: 'totalWeight', align: 'left', disablePadding: false, label: "TOTAL_WEIGHT", sortable: false },
  { id: 'totalVolume', align: 'left', disablePadding: false, label: "TOTAL_VOLUME", sortable: false },
  { id: 'totalPackages', align: 'left', disablePadding: false, label: "TOTAL_PACKAGES", sortable: false },
  { id: 'isPickup', align: 'center', disablePadding: true, label: 'IS_PICKUP_DESC', sortable:false },
  { id: 'submittedBy', align: 'center', disablePadding: true, label: 'SUBMITTED_BY'},
  { id: 'note', align: 'left', disablePadding: true, label: 'CONSOL_NOTE'},
  { id: 'action', align: 'center', disablePadding: false, label: 'ACTION' },
];

const StyledTableCell = withStyles(theme => ({
  body: {
      fontSize: 12,
  },
}))(TableCell);

const ACTION_KEYS = {
  EDIT: "EDIT",
  REPLICATE: "REPLICATE",
  EDIT_SHIPMENT: "EDIT_SHIPMENT",
  CREATE_SHIPMENT: "CREATE_SHIPMENT"
}
const ACTION2_KEYS = {
  EDIT_ORDER: "EDIT_ORDER",
  DRAFT: "DRAFT",
  SUBMITTED : "SUBMITTED",
  CONFIRMED: "CONFIRMED",
  RECEIVED: "RECEIVED",
  AWAITING_SHIPMENT: "AWAITING_SHIPMENT",
  INVOICE_DRAFT: "INVOICE_DRAFT",
  CREATE_FILE_INVOICE: "CREATE_FILE_INVOICE",
  CANCEL: "CANCEL",
  CHANGE_SCHEDULE: "CHANGE_SCHEDULE",
  CHANGE_SCHEDULE_SELECTED : "CHANGE_SCHEDULE_SELECTED",
  DRAFT_SELECTED: "DRAFT_SELECTED",
  SUBMITTED_SELECTED: "SUBMITTED_SELECTED",
  CONFIRMED_SELECTED: "CONFIRMED_SELECTED",
  RECEIVED_SELECTED: "RECEIVED_SELECTED",
  AWAITING_SHIPMENT_SELECTED: "AWAITING_SHIPMENT_SELECTED",
  INVOICE_DRAFT_SELECTED: "INVOICE_DRAFT_SELECTED",
}

function ConsolTableHead(props) {
  const intl = useIntl();
  const { user } = useSelector(state => state.auth);
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
          <StyledTableCell padding={"checkbox"}>
                    <Checkbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{ 'aria-label': 'Select all desserts' }}
                    />
          </StyledTableCell>
        {headRows.filter(row => !row.operatorOnly || user.userRole?.find(r => r.role === ROLES.OPERATOR)).map((row) => (
          <StyledTableCell
            key={row.id}
            align={row.align}
            padding={row.disablePadding ? "none" : "default"}
            sortDirection={orderBy === row.id ? order : false}
          >
            {row.sortable ? (
              <TableSortLabel
                active={orderBy === row.id}
                direction={order}
                onClick={createSortHandler(row.id)}
              >
                {intl.formatMessage({ id: row.label })}
              </TableSortLabel>
            ) : (intl.formatMessage({ id: row.label }))}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

ConsolTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles(theme => ({
  root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
  },
  highlight:
      theme.palette.type === 'light'
          ? {
              color: theme.palette.secondary.main,
              backgroundColor: lighten(theme.palette.secondary.light, 0.85),
          }
          : {
              color: theme.palette.text.primary,
              backgroundColor: theme.palette.secondary.dark,
          },
  spacer: {
      flex: '1 1 100%',
  },
  actions: {
      color: theme.palette.text.secondary,
  },
  title: {
      flex: '0 0 auto',
  },
}));

const ConsolTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected, user, customAction2, intl, selected,consolList} = props;

  return (
      <Toolbar
          className={clsx(classes.root, {
              [classes.highlight]: numSelected > 0,
          })}
      >
          <div className={classes.title}>
              {numSelected > 0 ? (
                  <Typography color="inherit" variant="subtitle1">
                      {numSelected} selected
                  </Typography>
              ) : (
                      <Typography variant="h6" id="tableTitle">
                          Orders
                      </Typography>
                  )}
          </div>
          <div className={classes.spacer} />
          <div className={classes.actions}>
              {numSelected > 0 ? ( <>
                  
                  {user.userRole?.find(r => r.role == ROLES.OPERATOR) &&
                    <DropdownButton id="dropdownStatus" as={ButtonGroup} title={intl.formatMessage({ id: "ACTIONS" })} size="sm" variant="success" onSelect={e => customAction2(e)}>
                        <Dropdown.Item eventKey={ACTION2_KEYS.DRAFT_SELECTED} disabled={!selected.every(id => { const item = consolList.find(o => o.id === id);
                                                                                                                      return (
                                                                                                                        item.status === CONSOL_STATUS.DRAFT ||
                                                                                                                        item.status === CONSOL_STATUS.SUBMITTED ||
                                                                                                                        item.status === CONSOL_STATUS.CONFIRMED ||
                                                                                                                        item.status === CONSOL_STATUS.RECEIVED
                                                                                                                      );
                                                                                                                    })}>{intl.formatMessage({ id: "DRAFT_SELECTED"})}</Dropdown.Item>
                        <Dropdown.Item eventKey={ACTION2_KEYS.SUBMITTED_SELECTED} disabled={!selected.every(id => { const item = consolList.find(o => o.id === id);
                                                                                                                      return (
                                                                                                                        item.status === CONSOL_STATUS.DRAFT ||
                                                                                                                        item.status === CONSOL_STATUS.SUBMITTED ||
                                                                                                                        item.status === CONSOL_STATUS.CONFIRMED ||
                                                                                                                        item.status === CONSOL_STATUS.RECEIVED
                                                                                                                      );
                                                                                                                    })}>{intl.formatMessage({ id: "SUBMITTED_SELECTED"})}</Dropdown.Item>
                        <Dropdown.Item eventKey={ACTION2_KEYS.CONFIRMED_SELECTED} disabled={!selected.every(id => { const item = consolList.find(o => o.id === id);
                                                                                                                      return (
                                                                                                                        item.status === CONSOL_STATUS.DRAFT ||
                                                                                                                        item.status === CONSOL_STATUS.SUBMITTED ||
                                                                                                                        item.status === CONSOL_STATUS.CONFIRMED ||
                                                                                                                        item.status === CONSOL_STATUS.RECEIVED
                                                                                                                      );
                                                                                                                    })}>{intl.formatMessage({ id: "CONFIRMED_SELECTED"})}</Dropdown.Item>
                        <Dropdown.Item eventKey={ACTION2_KEYS.RECEIVED_SELECTED} disabled={!selected.every(id => { const item = consolList.find(o => o.id === id);
                                                                                                                      return (
                                                                                                                        item.status === CONSOL_STATUS.DRAFT ||
                                                                                                                        item.status === CONSOL_STATUS.SUBMITTED ||
                                                                                                                        item.status === CONSOL_STATUS.CONFIRMED ||
                                                                                                                        item.status === CONSOL_STATUS.RECEIVED
                                                                                                                      );
                                                                                                                    })}>{intl.formatMessage({ id: "RECEIVED_SELECTED"})}</Dropdown.Item>
                        <Dropdown.Item eventKey={ACTION2_KEYS.AWAITING_SHIPMENT_SELECTED} disabled={selected.some(id=> consolList.find(o=> o.id == id).status != CONSOL_STATUS.RECEIVED)}>{intl.formatMessage({ id: "AWAITING_SHIPMENT_SELECTED"})}</Dropdown.Item>
                        {/*<Dropdown.Item eventKey={ACTION2_KEYS.INVOICE_DRAFT_SELECTED} disabled={selected.some(id=> consolList.find(o=> o.id == id).status != CONSOL_STATUS.DELIVERED || (!consolList.find(o=> o.id == id).totalVolume || !consolList.find(o=> o.id == id).totalWeight))}>{intl.formatMessage({ id: "INVOICE_DRAFT_SELECTED"})}</Dropdown.Item>*/}
                        <Dropdown.Item eventKey={ACTION2_KEYS.CHANGE_SCHEDULE_SELECTED}>{intl.formatMessage({ id: "CHANGE_SCHEDULE_SELECTED"})}</Dropdown.Item>
                    </DropdownButton>
                    
                }</>
                  
              ) : (
                      <Tooltip title="Filter list">
                          <IconButton aria-label="Filter list">
                              <FilterListIcon />
                          </IconButton>
                      </Tooltip>
                  )}
          </div>
      </Toolbar>
  );
};

ConsolTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({

  root: {
      width: '100%',
      marginTop: theme.spacing(3),
  },
  paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
  },
  table: {
      minWidth: 100
  },
  tableWrapper: {
      overflowX: 'auto',
  },
}));



function ConsolScheduleOrders(props) {
  const subheader = useSubheader();
  const { intl, history } = props;
  const { user } = useSelector(state => state.auth);
  const { flitSvc } = useContext(FlitServiceContext);
  const [isLoading, setIsLoading] = useState(true);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [consolList, setConsolList] = useState([]);
  const [invoiceList,setInvoiceList] = useState([]);
  const [dense, setDense] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [shipment, setShipment] = useState();
  const [consolSchedule,setConsolSchedule] = useState();
  const [sortedRoutes,setSortedRoutes] = useState([]);
  let { id } = useParams();

  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('submittedOn');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [statusFilter, setStatusFilter] = React.useState();
  const [showActualMeasurementDialog,setShowActualMeasurementDialog] = React.useState(false);
  const [showShipmentReadyDialog,setShowShipmentReadyDialog] = React.useState(false);
  const [showAvailableScheduleDialog, setShowAvailableScheduleDialog] = useState(false);
  const [showDueInputDialog,setShowDueInputDialog] = React.useState(false);
  const [tabValue, setTabValue] = React.useState(0);
  const [dueOn, setDueOn] = React.useState(new Date(moment().add(30,'d')));
  const [showInvoiceDialog,setShowInvoiceDialog] = React.useState(false);
  const [showNewConsolOrderDialog,setShowNewConsolOrderDialog] = React.useState(false);
  const [invoiceBilledToId, setInvoiceBilledToId] = React.useState();
  const [invoiceConsolId, setInvoiceConsolId] = React.useState();
  const [editingOrderId, setEditingOrderId] = useState(null);

  const initialEntry = {
    id : id,
    orders: []
  };
  
  // Updated validation schema - removed required validations for optional fields
  const UpdateRouteScheme = Yup.object().shape({
    orders: Yup.array()
      .of(
        Yup.object().shape({
          totalWeight: Yup.number().nullable().notRequired(),
          totalVolume: Yup.number().nullable().notRequired(),
          totalPackages: Yup.number().nullable().notRequired(),
          totalPackageType: Yup.string().nullable().notRequired(),
          incoterms: Yup.string().nullable().notRequired(),
          originDropOffOn: Yup.date().nullable().notRequired()
        })
      )
  });

  const [initialValues, setInitialValues] = useState(initialEntry);

  subheader.setTitle(intl.formatMessage({ id: "MENU.FBA_CONSOLIDATION" }));
  const classes = useStyles();
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, (totalRows) - page * rowsPerPage);


  
  // Add this helper function at the top of the file, after the imports
function formatCurrencyAmount(value) {
  if (!value && value !== 0) return '';
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  // Format with commas but without forcing decimal places
  const parts = num.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}

function parseFormattedNumber(value) {
  if (!value) return '';
  return value.toString().replace(/,/g, '');
}

// Add currency validation array (add this near the top with other constants)
const VALID_CURRENCIES = ['USD', 'EUR', 'GBP', 'JPY', 'CNY', 'KRW', 'CAD', 'AUD', 'CHF', 'HKD', 'SGD', 'SEK', 'NOK', 'DKK', 'INR', 'BRL', 'RUB', 'MXN', 'ZAR', 'TRY', 'NZD', 'THB', 'MYR', 'IDR', 'PHP', 'VND'];


  function refresh() {
    setIsLoading(true);
    setSelected([]);
    flitSvc.getConsolSchedule(id).then(({ data }) => {
      setConsolSchedule(data);
      if (data.shipmentId) {
        flitSvc.getShipment(data.shipmentId).then(({data}) => {
          setShipment(data);
          setSortedRoutes(sortRoutes(data.route));
        }).finally(() => {
          setIsLoading(false);
        });
      } else {
        setIsLoading(false)
      }
      setIsLoading(true)
      flitSvc.getConsolsForSchedule(id).then(({data}) =>{
      var list = data.value?.map(item => {
        return {
          ...item,
          // Initialize editable fields with original values if not already set
          isPickup: item.isPickup !== undefined ? item.isPickup : item.activity.quoteRequest[0]?.isPickup,
          incoterms: item.incoterms || item.activity.quoteRequest[0]?.incoterms || '',
          totalWeight: item.totalWeight || 0,
          totalVolume: item.totalVolume || 0,
          totalPackageType: item.totalPackageType || '',
          totalPackages: item.totalPackages || 0,
          houseBillNo: item.houseBillNo || '',
          note: item.note || '',
          originDropOffOn: item.originDropOffOn || null,
          // FIX: Reset the update flags
          needsUpdate: false,
          needsUpdateExtras: false,
          // Initialize consolExtraTemp if it exists (important for validation state)
          consolExtraTemp: item.consolExtraTemp ? {
            consolId: item.id,
            quotedVolume: item.consolExtraTemp.quotedVolume ?? null,
            quotedRate: item.consolExtraTemp.quotedRate ?? null,
            quotedRateCurrency: item.consolExtraTemp.quotedRateCurrency ?? null,
            trukingCost: item.consolExtraTemp.trukingCost ?? null,
            truckingCostCurrency: item.consolExtraTemp.truckingCostCurrency ?? null,
            truckingRevenue: item.consolExtraTemp.truckingRevenue ?? null,
            truckingRevenueCurrency: item.consolExtraTemp.truckingRevenueCurrency ?? null,
            customsCost: item.consolExtraTemp.customsCost ?? null,
            customsCostCurrency: item.consolExtraTemp.customsCostCurrency ?? null,
            customsRevenue: item.consolExtraTemp.customsRevenue ?? null,
            customsRevenueCurrency: item.consolExtraTemp.customsRevenueCurrency ?? null,
            _3plcost: item.consolExtraTemp._3plcost ?? null,
            _3plcostCurrency: item.consolExtraTemp._3plcostCurrency ?? null,
            crossDockingCost: item.consolExtraTemp.crossDockingCost ?? null,
            crossDockingCostCurrency: item.consolExtraTemp.crossDockingCostCurrency ?? null,
            fsvpps: item.consolExtraTemp.fsvpps ?? null,
            fsvppscurrency: item.consolExtraTemp.fsvppscurrency ?? null,
            memo: item.consolExtraTemp.memo ?? null,
            // NEW FIELDS
            fdaFilingFee: item.consolExtraTemp.fdaFilingFee ?? null,
            fdaFilingFeeCurrency: item.consolExtraTemp.fdaFilingFeeCurrency ?? null,
            fdaPriorNoticeFee: item.consolExtraTemp.fdaPriorNoticeFee ?? null,
            fdaPriorNoticeFeeCurrency: item.consolExtraTemp.fdaPriorNoticeFeeCurrency ?? null,
            ddp: item.consolExtraTemp.ddp ?? null,
            ddPcurrency: item.consolExtraTemp.ddPcurrency ?? null,
            singleBond: item.consolExtraTemp.singleBond ?? null,
            singleBondCurrency: item.consolExtraTemp.singleBondCurrency ?? null,
            insurance: item.consolExtraTemp.insurance ?? null,
            insuranceCurrency: item.consolExtraTemp.insuranceCurrency ?? null,
            isftAbenefit: item.consolExtraTemp.isftAbenefit,
            isfdAconfirmed: item.consolExtraTemp.isfdAconfirmed,
            fdAmemo: item.consolExtraTemp.fdAmemo ?? null
          } : null
        };
      });
      setConsolList(list);
      setInitialValues({id:id,orders:list});
      setTotalRows(list.filter(row=> !statusFilter ? row.status != CONSOL_STATUS.CANCELLED : row.status == statusFilter)?.length);
      
    }).finally(() => {
      setIsLoading(false);
    });
      setIsLoading(true)
      flitSvc.getInvoicesForSchedule(id).then(({data}) =>{
        setInvoiceList(data);
        
      }
      ).finally(() => {
        setIsLoading(false);
      });
      
    })
  }

  useEffect(() => {
    if(id) refresh();
  }, [id]);

  useEffect(() => {
    setTotalRows(consolList.filter(row=> !statusFilter ? row.status != CONSOL_STATUS.CANCELLED : row.status == statusFilter)?.length);
    setPage(0);
  }, [statusFilter]);

  function _filterCallback(option, props) {
    return true;
  }
  const isSelected = name => selected.indexOf(name) !== -1;
  function handleRequestSort(event, property) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
}

function handleSelectAllClick(event) {
    if (event.target.checked) {
        // FIX: Only select filtered/visible items, not all items
        const newSelecteds = consolList
            .filter(row=> !statusFilter ? row.status != CONSOL_STATUS.CANCELLED : row.status == statusFilter)
            .map(n => n.id);
        setSelected(newSelecteds);
        return;
    }
    setSelected([]);
}

function handleClick(event, name) {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
            selected.slice(0, selectedIndex),
            selected.slice(selectedIndex + 1),
        );
    }

    setSelected(newSelected);
}

function handleChangePage(event, newPage) {
    setPage(newPage);
}

function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
}
  function closeErrorDialog(){
    setShowErrorDialog(false);
  }

  function customAction(actionKey, id, shipmentId) {
    switch (actionKey) {
        case ACTION_KEYS.EDIT:
            history.push("/consol/schedule/" + id);
            break;
        case ACTION_KEYS.REPLICATE:
            history.push("/consol/schedule?replicate=" + id);
            break;
        case ACTION_KEYS.EDIT_SHIPMENT:
            history.push("/shipment/" + shipmentId + "/edit");
            break;
        case ACTION_KEYS.CREATE_SHIPMENT:
            setIsLoading(true);
            flitSvc.createShipmentFromConsolSchedule(id).then(({ data }) => {
                history.push("/shipment/" + data.shipmentId + "/edit");
            }).finally(() => {
                setIsLoading(false);
            });
            
            break;
        default:
            break;
    }
};

function customAction2(actionKey, id, billedToId) {
  switch (actionKey) {
    case ACTION2_KEYS.EDIT_ORDER:
      setEditingOrderId(id);
      setShowNewConsolOrderDialog(true);
      break;
    case ACTION2_KEYS.DRAFT:
        setIsLoading(true);
          flitSvc.updateConsolStatus(id,CONSOL_STATUS.DRAFT).then(({ data }) => {
            refresh();
          });
          break;
    case ACTION2_KEYS.SUBMITTED:
        setIsLoading(true);
          flitSvc.updateConsolStatus(id,CONSOL_STATUS.SUBMITTED).then(({ data }) => {
            refresh();
          });
          break;
      case ACTION2_KEYS.CONFIRMED:
        setIsLoading(true);
          flitSvc.updateConsolStatus(id,CONSOL_STATUS.CONFIRMED).then(({ data }) => {
            refresh();
          });
          break;
      case ACTION2_KEYS.RECEIVED:
        setIsLoading(true);
        flitSvc.updateConsolStatus(id,CONSOL_STATUS.RECEIVED).then(({ data }) => {
          refresh();
        });
        break;
      case ACTION2_KEYS.INPUT_ACTUAL_MEASUREMENT:
        setShowActualMeasurementDialog(true);
      break;
      case ACTION2_KEYS.AWAITING_SHIPMENT:
        setShowShipmentReadyDialog(id);
    break;
      case ACTION2_KEYS.INVOICE_DRAFT:
          setShowDueInputDialog(id);
          break;
      case ACTION2_KEYS.CREATE_FILE_INVOICE:
          openInvoiceDialog(id,billedToId)
        break;
      case ACTION2_KEYS.CANCEL:
        setIsLoading(true);
        flitSvc.updateConsolStatus(id,CONSOL_STATUS.CANCELLED).then(({ data }) => {
          refresh();
        });
          break;
      case ACTION2_KEYS.DRAFT_SELECTED:
        if (!selected || selected.length ==0 ) break;
        setIsLoading(true);
        var updateObservableDraft = [];
        selected.forEach((id) => {
          updateObservableDraft.push(flitSvc.updateConsolStatus(id,CONSOL_STATUS.DRAFT));
        });
        forkJoin(updateObservableDraft).subscribe(res=> {
          refresh();
        }, err => {
          //
        });
        break;
      case ACTION2_KEYS.SUBMITTED_SELECTED:
        if (!selected || selected.length ==0 ) break;
        setIsLoading(true);
        var updateObservable = [];
        selected.forEach((id) => {
          updateObservable.push(flitSvc.updateConsolStatus(id,CONSOL_STATUS.SUBMITTED));
        });
        forkJoin(updateObservable).subscribe(res=> {
          refresh();

        }, err => {
          //
        });
        break;
      case ACTION2_KEYS.CONFIRMED_SELECTED:
        if (!selected || selected.length ==0 ) break;
        setIsLoading(true);
        var updateObservable = [];
        selected.forEach((id) => {
          updateObservable.push(flitSvc.updateConsolStatus(id,CONSOL_STATUS.CONFIRMED));
        });
        forkJoin(updateObservable).subscribe(res=> {
          refresh();

        }, err => {
          //
        });
        break;
      case ACTION2_KEYS.RECEIVED_SELECTED:
        if (!selected || selected.length ==0 ) break;
        setIsLoading(true);
        var updateObservable2 = [];
        selected.forEach((id) => {
          updateObservable2.push(flitSvc.updateConsolStatus(id,CONSOL_STATUS.RECEIVED));
        });
        forkJoin(updateObservable2).subscribe(res=> {
          refresh();
        }, err => {
          //
        });
        break;
      case ACTION2_KEYS.AWAITING_SHIPMENT_SELECTED:
        if (!selected || selected.length ==0 ) break;
        setShowShipmentReadyDialog('selected');
        break;
      case ACTION2_KEYS.INVOICE_DRAFT_SELECTED:
        if (!selected || selected.length ==0 ) break;
        setShowDueInputDialog('selected');
        break;

        case ACTION2_KEYS.CHANGE_SCHEDULE:
          setShowAvailableScheduleDialog([id]);
          break;
        case ACTION2_KEYS.CHANGE_SCHEDULE_SELECTED:
          if (!selected || selected.length ==0 ) break;
          setShowAvailableScheduleDialog(selected);
          break;
      default:
          break;
  }
};

function handleTabChange(event, newValue) {
  if (!isLoading) {
    // Reset to fresh data when switching tabs
    if (newValue == 1 || newValue == 2) {
      setInitialValues({id:id, orders: consolList});
    }
    setTabValue(newValue);
  } 
}


function onHideDueInputDialog() {
  setShowDueInputDialog(false);
}

function onHideShipmentReadyDialog() {
  setShowShipmentReadyDialog(false);
}


function handleTabChange(event, newValue) {
  if (!isLoading) {
    if (newValue == 1) {
      setInitialValues({id:id,orders:consolList});
    }
    setTabValue(newValue);
  } 

}

function closeAvailableScheduleDialog(isUpdated){
  setShowAvailableScheduleDialog(false);
  if (isUpdated) { 
    refresh();
  }
  
}

function openInvoiceDialog(consolId,billedToId) {
  setInvoiceBilledToId(billedToId);
  setInvoiceConsolId(consolId);
  setShowInvoiceDialog(true);
}


function handleCloseInvoiceDialog(isUpdated) {
  setShowInvoiceDialog(false);
  if (isUpdated) {
    refresh();
  }
}
function openNewConsolOrderDialog() {
  setShowNewConsolOrderDialog(true);
}

function handleCloseNewConsolOrderDialog(isUpdated) {
  setShowNewConsolOrderDialog(false);
  setEditingOrderId(null); 
  if (isUpdated) {
    refresh();
  }
}


function downloadFile(documentId, fileName) {
  flitSvc.getDownloadLink(documentId).then(res => {
      // on the fly download trick
      const link = document.createElement('a');
      link.href = res.data.url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  })
}

  return (<>
  <Row>
    <Col className="d-none d-md-block">
      <Card>
      <CardHeader title={intl.formatMessage({ id: "SCHEDULE_INFORMATION" })}>
          <CardHeaderToolbar>
          <span className={getScheduleStatusCssClasses(consolSchedule?.status)+ " mr-4"}>{cf.format('ConsolScheduleStatus',consolSchedule?.status,intl.locale)}</span>
          {user.userRole?.find(r => r.role == ROLES.OPERATOR) &&
              <DropdownButton id="dropdownStatus" as={ButtonGroup} title={intl.formatMessage({ id: "ACTIONS" })} size="sm" variant="success" onSelect={e => customAction(e, consolSchedule?.id,consolSchedule?.shipmentId)}>
                  <Dropdown.Item eventKey={ACTION_KEYS.EDIT}>{intl.formatMessage({ id: "EDIT" })}</Dropdown.Item>
                  <Dropdown.Item eventKey={ACTION_KEYS.REPLICATE}>{intl.formatMessage({ id: "REPLICATE_BUTTON" })}</Dropdown.Item>
                  {consolSchedule?.shipmentId ? <Dropdown.Item eventKey={ACTION_KEYS.EDIT_SHIPMENT}>{intl.formatMessage({ id: "EDIT_SHIPMENT"})}</Dropdown.Item> : 
                  <Dropdown.Item eventKey={ACTION_KEYS.CREATE_SHIPMENT}>{intl.formatMessage({ id: "CREATE_SHIPMENT"})}</Dropdown.Item>}
              </DropdownButton>
          }
          </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <Row>
              <Col>
              {consolSchedule?.consolRateDocument && <Row className="mt-3">
                <Col md="6">
                    {intl.formatMessage({ id: "CONSOL_RATE_DOCUMENT" })}
                  </Col>
                <Col md="6"><Link style={{ cursor: "pointer" }} onClick={() => downloadFile(consolSchedule.consolRateDocument.id, consolSchedule?.consolRateDocument.fileName)}><AttachFileIcon />{consolSchedule?.consolRateDocument.fileName}</Link></Col>
                </Row>}
                <Row className="mt-3">
                <Col md="6">
                    {intl.formatMessage({ id: "MASTER_BILL_NO" })}
                  </Col>
                  <Col md="6">{consolSchedule?.masterBillNo}</Col>
                </Row>
                <Row>
                <Col md="6">
                    {intl.formatMessage({ id: "BOOKING_NUMBER" })}
                  </Col>
                  <Col md="6">{consolSchedule?.bookingNo}</Col>
                </Row>
                <Row>
                  <Col md="6">
                    {intl.formatMessage({ id: "ESTIMATED_DEPARTURE_ON" })}
                  </Col>
                  <Col md="6"><Moment format="LL">{consolSchedule?.estimatedDepartureOn}</Moment></Col>
                </Row>
                <Row>
                  <Col md="6">
                    {intl.formatMessage({ id: "ESTIMATED_ARRIVAL_ON" })}
                  </Col>
                  <Col md="6"><Moment format="LL">{consolSchedule?.estimatedArrivalOn}</Moment></Col>
                </Row>
                <Row>
                  <Col md="6">
                    {intl.formatMessage({ id: "DOCUMENT_CUT_OFF_ON" })}
                  </Col>
                  <Col md="6"><Moment format="LL">{consolSchedule?.documentCutOffOn}</Moment></Col>
                </Row>
                <Row>
                  <Col md="6">
                    {intl.formatMessage({ id: "FREIGHT_CUT_OFF_ON" })}
                  </Col>
                  <Col md="6"><Moment format="LL">{consolSchedule?.freightCutOffOn}</Moment></Col>
                </Row>

              </Col>
              <Col>
                {!consolSchedule?.shipmentId ? <Row>
                  <Col>
                  {consolSchedule && <ConsolRouteSummary consolSchedule={consolSchedule}/>}
                  </Col>
                </Row> :
                <Row>
                  <Col>
                    {shipment &&<RouteSummary route={shipment.route} />}
                  </Col>
                </Row>}

              </Col>
            </Row>
          
        
          </CardBody>
          </Card>
    
    </Col>
  </Row>
    <Row>
      <Col>
    <Card>
      <CardHeader title={intl.formatMessage({ id: "CONSOL_ORDER_MANAGEMENT" })}>
        <CardHeaderToolbar>
                  <Button style={{ float: "right" }} onClick={() => {
                    openNewConsolOrderDialog(true); 
                  }} disabled={!consolSchedule} >{intl.formatMessage({ id: "NEW_CONSOL_ORDER" })}</Button>
                </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label={intl.formatMessage({ id: "CONSOL_ORDER_LIST" })} />
        <Tab label={intl.formatMessage({ id: "ADVANCED" })} />
        <Tab label={intl.formatMessage({ id: "EXTRA_FIELDS" })} />
      </Tabs>
      {tabValue === 0 && <>
        <Row className="mt-8">
          <Col className="d-flex align-items-center flex-wrap">
              <Form.Group controlId="status" className="mr-7">
                <Form.Control as="select" value={statusFilter} onChange={e => {
                  setStatusFilter(e.target.value);
                  setPage(0);
                }}>
                  <option value=''> {intl.formatMessage({ id: "ALL_ACTIVE_ORDER" })}</option>
                  <option value={CONSOL_STATUS.DRAFT}>{cf.format('ConsolStatus', CONSOL_STATUS.DRAFT, intl.locale)}</option>
                  <option value={CONSOL_STATUS.SUBMITTED}>{cf.format('ConsolStatus', CONSOL_STATUS.SUBMITTED, intl.locale)}</option>
                  <option value={CONSOL_STATUS.CONFIRMED}>{cf.format('ConsolStatus', CONSOL_STATUS.CONFIRMED, intl.locale)}</option>
                  <option value={CONSOL_STATUS.RECEIVED}>{cf.format('ConsolStatus', CONSOL_STATUS.RECEIVED, intl.locale)}</option>
                  <option value={CONSOL_STATUS.AWAITING_SHIPMENT}>{cf.format('ConsolStatus', CONSOL_STATUS.AWAITING_SHIPMENT, intl.locale)}</option>
                  <option value={CONSOL_STATUS.SHIPPED}>{cf.format('ConsolStatus', CONSOL_STATUS.SHIPPED, intl.locale)}</option>
                  <option value={CONSOL_STATUS.DELIVERED}>{cf.format('ConsolStatus', CONSOL_STATUS.DELIVERED, intl.locale)}</option>
                  <option value={CONSOL_STATUS.CANCELLED}>{cf.format('ConsolStatus', CONSOL_STATUS.CANCELLED, intl.locale)}</option>
                </Form.Control>
                <Form.Text className="text-muted">
                  <b>{intl.formatMessage({ id: "FILTER" })}</b>{" "}
                  {intl.formatMessage({ id: "STATUS" })}
                </Form.Text>
              </Form.Group>

            
          </Col>
        </Row>

        {!isLoading && consolList.length === 0 && (
                        <Row className="border-top pt-5">
                          <Col style={{ textAlign: "center" }}>
                            <img
                              src={cargoImage}
                              alt="CargoImage"
                              style={{
                                height: "100px",
                                marginTop: "20px",
                                marginBottom: "10px",
                              }}
                            />
                            <br />
                            {intl.formatMessage({ id: "NO_CONSOL_ORDER" })}
                          </Col>
                        </Row>
                    )}
        
          <Row>
            <Col>
            {selected.length !== 0 && (<ConsolTableToolbar numSelected={selected.length} customAction2={customAction2} user={user} intl={intl} selected={selected} consolList={consolList}/>)}
              {(isLoading || consolList.length != 0) && <>{isLoading && <LinearProgress />}
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={dense ? 'small' : 'medium'}
        >
          
          <ConsolTableHead
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={totalRows}
          >
          </ConsolTableHead>
          <TableBody>
          {stableSort(consolList, getSorting(order, orderBy))
                        .filter(row=> !statusFilter ? row.status != CONSOL_STATUS.CANCELLED : row.status == statusFilter)
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, index) => {
                            const isItemSelected = isSelected(row.id);
                            const labelId = `enhanced-table-checkbox-${index}`;
                            return (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    aria-checked={isItemSelected}
                                    tabIndex={-1}
                                    key={row.id}
                                    selected={isItemSelected}
                                >
                                    <StyledTableCell padding={"checkbox"}
                                        onClick={event => handleClick(event, row.id)}
                                    >
                                        <Checkbox
                                            checked={isItemSelected}
                                            inputProps={{ 'aria-labelledby': labelId }}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell align="left" onClick={() => history.push('/consol/'+row.id)}><span className={getConsolStatusCssClasses(row.status)}>{cf.format('ConsolStatus',row.status,intl.locale)}</span></StyledTableCell>
                                    <StyledTableCell align="left" onClick={() => history.push('/consol/'+row.id)}>{(row.activity.quoteRequest[0]?.submittedBy.businessEntity?.legalName)}</StyledTableCell>
                                    <StyledTableCell align="left" onClick={() => history.push('/consol/'+row.id)}><Moment format="ll">{row.activity.quoteRequest[0]?.submittedOn}</Moment></StyledTableCell>
                                    <StyledTableCell align="left" onClick={() => history.push('/consol/'+row.id)}>{row.originDropOffOn ? <Moment format="ll">{row.originDropOffOn}</Moment> : "" }</StyledTableCell>
                                    <StyledTableCell align="left" onClick={() => history.push('/consol/'+row.id)}>{row.houseBillNo}</StyledTableCell>
                                    <StyledTableCell align="left" onClick={() => history.push('/consol/'+row.id)}>{row.incoterms ? <b>{row.incoterms}</b> : <span className="text-muted">{row.activity.quoteRequest[0]?.incoterms}</span> }</StyledTableCell> 
                                    <StyledTableCell align="left" onClick={() => history.push('/consol/'+row.id)}>{row.totalWeight == 0 ? <span className="text-muted">{row.activity.quoteRequest[0]?.totalWeight + (row.activity.quoteRequest[0]?.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ? ' kg' : ' lb') }</span>: <b>{row.totalWeight + (row.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ? ' kg' : ' lb')}</b>}</StyledTableCell>
                                    <StyledTableCell align="left" onClick={() => history.push('/consol/'+row.id)}>{row.totalVolume == 0 ? <span className="text-muted">{row.activity.quoteRequest[0]?.totalVolume + (row.activity.quoteRequest[0]?.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ? ' cbm' : ' cbf') }</span>: <b>{row.totalVolume + (row.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ? ' cbm' : ' cbf')}</b>}</StyledTableCell>
                                    <StyledTableCell align="left" onClick={() => history.push('/consol/'+row.id)}>
                                      {row.totalPackages ? row.totalPackages : '-'} {cf.format('PackageType', row.totalPackageType, intl.locale)}
                                    </StyledTableCell>
                                    <StyledTableCell align="center" onClick={() => history.push('/consol/'+row.id)}>
                                      <Checkbox checked={row.activity.quoteRequest[0]?.isPickup || false} disabled />
                                    </StyledTableCell>
                                    <StyledTableCell align="center" onClick={() => history.push('/consol/'+row.id)}>{((row.activity.quoteRequest[0]?.submittedBy.firstName??"") + " " + (row.activity.quoteRequest[0]?.submittedBy.lastName??""))}</StyledTableCell>
                                    <StyledTableCell align="left" onClick={() => history.push('/consol/'+row.id)}>{row.note}</StyledTableCell>
                                    <StyledTableCell align="center">
                                                {user.userRole?.find(r => r.role == ROLES.OPERATOR) &&
                                                    <DropdownButton id="dropdownStatus" as={ButtonGroup} title={intl.formatMessage({ id: "ACTIONS" })} size="sm" variant="success" onSelect={e => customAction2(e, row.id,row.activity.quoteRequest[0]?.submittedBy.businessEntity?.id)}>
                                                      <Dropdown.Item eventKey={ACTION2_KEYS.EDIT_ORDER}>{intl.formatMessage({ id: "EDIT" })}</Dropdown.Item>
                                                        {(row.status == CONSOL_STATUS.DRAFT || row.status == CONSOL_STATUS.SUBMITTED || row.status == CONSOL_STATUS.CONFIRMED || row.status == CONSOL_STATUS.RECEIVED) && <>
                                                          {row.status != CONSOL_STATUS.DRAFT && <Dropdown.Item eventKey={ACTION2_KEYS.DRAFT}>{cf.format('ConsolStatus',CONSOL_STATUS.DRAFT,intl.locale)}</Dropdown.Item>}
                                                          {row.status != CONSOL_STATUS.SUBMITTED && <Dropdown.Item eventKey={ACTION2_KEYS.SUBMITTED}>{cf.format('ConsolStatus',CONSOL_STATUS.SUBMITTED,intl.locale)}</Dropdown.Item>}
                                                          {row.status != CONSOL_STATUS.CONFIRMED && <Dropdown.Item eventKey={ACTION2_KEYS.CONFIRMED}>{cf.format('ConsolStatus',CONSOL_STATUS.CONFIRMED,intl.locale)}</Dropdown.Item>}
                                                          {row.status != CONSOL_STATUS.RECEIVED && <Dropdown.Item eventKey={ACTION2_KEYS.RECEIVED}>{cf.format('ConsolStatus',CONSOL_STATUS.RECEIVED,intl.locale)}</Dropdown.Item>}
                                                        </>}
                                                        {row.status == CONSOL_STATUS.RECEIVED ? <Dropdown.Item eventKey={ACTION2_KEYS.AWAITING_SHIPMENT}>{cf.format('ConsolStatus',CONSOL_STATUS.AWAITING_SHIPMENT,intl.locale)}</Dropdown.Item> :
                                                        (row.status == CONSOL_STATUS.DELIVERED)  ?  <Dropdown.Item eventKey={ACTION2_KEYS.CREATE_FILE_INVOICE}>{intl.formatMessage({ id: "CREATE_INVOICE"})}</Dropdown.Item> : <></>}
                                                        <Dropdown.Item eventKey={ACTION2_KEYS.CHANGE_SCHEDULE}>{intl.formatMessage({ id: "CHANGE_SCHEDULE"})}</Dropdown.Item>
                                                        <Dropdown.Item eventKey={ACTION2_KEYS.CANCEL}>{intl.formatMessage({ id: "CANCEL"})}</Dropdown.Item>
                                                    </DropdownButton>
                                                }
                                    </StyledTableCell>                                        
                                </TableRow>
                            );
                        })}
                        {emptyRows > 0 && (
                        <TableRow style={{ height: 49 * emptyRows }}>
                            <StyledTableCell colSpan={13} />
                        </TableRow>
                    )}
          </TableBody>
        </Table></>
      }
              {!isLoading && <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={totalRows}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': `${intl.formatMessage({ id: "PREVIOUS_PAGE" })}`,
                    }}
                    nextIconButtonProps={{
                        'aria-label': `${intl.formatMessage({ id: "NEXT_PAGE" })}`,
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />}
            </Col>
          </Row>
          </>}
      {tabValue === 1 &&
      <>
      <Row className='mt-8'>
      <Col className="d-flex align-items-center flex-wrap">
      <Form.Group controlId="statusAdvanced">
        <Form.Control as="select" value={statusFilter} onChange={e => {
          setStatusFilter(e.target.value);
        }}>
          <option value=''> {intl.formatMessage({ id: "ALL_ACTIVE_ORDER" })}</option>
          <option value={CONSOL_STATUS.DRAFT}>{cf.format('ConsolStatus', CONSOL_STATUS.DRAFT, intl.locale)}</option>
          <option value={CONSOL_STATUS.SUBMITTED}>{cf.format('ConsolStatus', CONSOL_STATUS.SUBMITTED, intl.locale)}</option>
          <option value={CONSOL_STATUS.CONFIRMED}>{cf.format('ConsolStatus', CONSOL_STATUS.CONFIRMED, intl.locale)}</option>
          <option value={CONSOL_STATUS.RECEIVED}>{cf.format('ConsolStatus', CONSOL_STATUS.RECEIVED, intl.locale)}</option>
          <option value={CONSOL_STATUS.AWAITING_SHIPMENT}>{cf.format('ConsolStatus', CONSOL_STATUS.AWAITING_SHIPMENT, intl.locale)}</option>
          <option value={CONSOL_STATUS.SHIPPED}>{cf.format('ConsolStatus', CONSOL_STATUS.SHIPPED, intl.locale)}</option>
          <option value={CONSOL_STATUS.DELIVERED}>{cf.format('ConsolStatus', CONSOL_STATUS.DELIVERED, intl.locale)}</option>
          <option value={CONSOL_STATUS.CANCELLED}>{cf.format('ConsolStatus', CONSOL_STATUS.CANCELLED, intl.locale)}</option>
        </Form.Control>
        <Form.Text className="text-muted">
          <b>{intl.formatMessage({ id: "FILTER" })}</b>{" "}
          {intl.formatMessage({ id: "STATUS" })}
        </Form.Text>
      </Form.Group>
    </Col>
    </Row>
      
        <Row>
          
              <Col style={{ display: "table" }}>
              <Formik
        enableReinitialize={true}
        //validationSchema={UpdateRouteScheme}
        initialValues={initialValues}
        validateOnChange={true}
        onSubmit={(values,{ touched, setSubmitting }) => {
            var updateObservable = [];
            values.orders.filter(o=> o.needsUpdate).forEach((order) => {
              updateObservable.push(flitSvc.updateConsolDataInMetric(order.id,order.status,order.incoterms,order.houseBillNo, order.totalWeight, order.totalVolume,order.totalPackageType,order.totalPackages,order.measurementSystem,order.isPickup,order.originDropOffOn,order.note));
            });
            if (updateObservable.length > 0 ) {
              forkJoin(updateObservable).subscribe(res=> {
              setSubmitting(false);
              refresh();
            }, err => {
              //
            });
          } else {
            setSubmitting(false);
          }
          
        }}
      >
        {({
          values,
          status,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          validateField,
          setFieldValue,
          setFieldTouched,
          isSubmitting,
          validateForm,
          setErrors
        }) => {
           // ADD: Apply sorting before filtering (same as main tab)
          const getSortedAndFilteredOrders = (orders) => {
            return stableSort(orders, getSorting(order, orderBy))
              .filter(order => 
                !statusFilter 
                  ? order.status !== CONSOL_STATUS.CANCELLED 
                  : order.status === statusFilter
              );
          };

          const filteredOrders = getSortedAndFilteredOrders(values.orders);
                    
          const visibleOrderIndices = stableSort(values.orders, getSorting(order, orderBy))
          .map((order, index) => {
            const shouldShow = !statusFilter 
              ? order.status !== CONSOL_STATUS.CANCELLED 
              : order.status === statusFilter;
            return shouldShow ? values.orders.findIndex(o => o.id === order.id) : null;
          })
          .filter(index => index !== null);
          
          // Calculate summaries using filtered orders
          const totalWeight = filteredOrders.reduce((sum, order) => sum + (parseFloat(order.totalWeight) || 0), 0);
          const totalVolume = filteredOrders.reduce((sum, order) => sum + (parseFloat(order.totalVolume) || 0), 0);
          
          // Group packages by type using filtered orders
          const packagesByType = filteredOrders.reduce((acc, order) => {
            if (order.totalPackageType && order.totalPackages) {
              const type = order.totalPackageType;
              acc[type] = (acc[type] || 0) + (parseFloat(order.totalPackages) || 0);
            }
            return acc;
          }, {});

          // Create summary rows
          const summaryRows = [
            // Total Weight row
            [
              { value: intl.formatMessage({ id: "TOTAL" }), readOnly: true, className: "pl-2 pr-2 font-weight-bold" },
              ...Array(8).fill({ value: '', readOnly: true, className: 'pl-2 pr-2' }),
              { value: totalWeight.toFixed(2) + ' kg', readOnly: true, className: "pl-2 pr-2 font-weight-bold bg-light-primary" },
              { value: totalVolume.toFixed(2) + ' cbm', readOnly: true, className: "pl-2 pr-2 font-weight-bold bg-light-primary" },
              ...Array(5).fill({ value: '', readOnly: true, className: 'pl-2 pr-2' })
            ],
            // Package type summary rows
            ...Object.entries(packagesByType).map(([packageType, count]) => [
              { value: intl.formatMessage({ id: "TOTAL" }) + ' - ' + cf.format('PackageType', packageType, intl.locale), readOnly: true, className: "pl-2 pr-2 font-weight-bold" },
              ...Array(10).fill({ value: '', readOnly: true, className: 'pl-2 pr-2' }),
              { value: packageType, readOnly: true, className: "pl-2 pr-2 font-weight-bold bg-light-info" },
              { value: count, readOnly: true, className: "pl-2 pr-2 font-weight-bold bg-light-info" },
              ...Array(3).fill({ value: '', readOnly: true, className: 'pl-2 pr-2' })
            ])
          ];
                    return (<>
            <Form
              onSubmit={handleSubmit}
              noValidate
              autoComplete="off"
              className="form form-label-right"
            >
              <Row className="mb-2">
                <Col>
                <div className="fv-plugins-message-container"><div className="fv-help-block">{intl.formatMessage({ id: "ADVANCED_HINT" })}</div></div>
              <br/>
              </Col><Col>
              <button
                    type='submit'
                    disabled={isSubmitting || isLoading || !(touched.orders && !touched.orders.some( t => {
                      return t && ( 
                        (t.totalWeight && t.totalWeight != 1) || 
                        (t.totalVolume && t.totalVolume != 1) ||
                        (t.incoterms && t.incoterms != 1) ||
                        (t.totalPackageType && t.totalPackageType != 1) ||
                        (t.totalPackages && t.totalPackages != 1) ||
                        (t.originDropOffOn && t.originDropOffOn != 1)
                      )
                    }))}
                    className={`btn btn-warning btn-elevate float-right kt-login__btn-primary`}
                >
                    {intl.formatMessage({ id: "SAVE_CHANGES" })}
                    {isSubmitting && <span className="ml-3 mr-5 spinner spinner-white"></span>}
                </button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <ReactDataSheet
                    data={[[
                      {value:intl.formatMessage({ id: "ORDER_ID" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "STATUS" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "BUSINESS_ENTITY" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "DESCRIPTION" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "SUBMITTED_BY" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "REQUESTED_WEIGHT" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "REQUESTED_VOLUME" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "INCOTERMS" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "HBL" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "ACTUAL_WEIGHT_IN_KG" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "ACTUAL_VOLUME_IN_CBM" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "PACKAGE_TYPE" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "TOTAL_PACKAGES" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "IS_PICKUP_DESC" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "ORIGIN_DROPOFF_ON" }),readOnly:true,className:"pl-2 pr-2"},
                      {value:intl.formatMessage({ id: "CONSOL_NOTE" }),readOnly:true,className:"pl-2 pr-2"}
                    ]].concat(filteredOrders.map((order,displayIndex)=>{ 
                      const index = visibleOrderIndices[displayIndex];
                      return [
                        { value: "FLIT-C-" + order.id, readOnly: true, className: "pl-2 pr-2" },
                        { value: cf.format('ConsolStatus',order.status,intl.locale), readOnly: true, className: "pl-2 pr-2" },
                        { value: order.activity.quoteRequest[0]?.submittedBy.businessEntity?.legalName, readOnly: true, className: "pl-2 pr-2" },
                        { value: order.activity.quoteRequest[0]?.description, readOnly: true, className: "pl-2 pr-2" },
                        { value: ((order.activity.quoteRequest[0]?.submittedBy.firstName??"") + " " + (order.activity.quoteRequest[0]?.submittedBy.lastName??"")), readOnly: true, className: "pl-2 pr-2" },
                        { value: order.activity.quoteRequest[0]?.totalWeight + (order.activity.quoteRequest[0]?.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ? ' kg' : ' lb'), readOnly: true, className: "pl-2 pr-2" },
                        { value: order.activity.quoteRequest[0]?.totalVolume + (order.activity.quoteRequest[0]?.measurementSystem == MEASUREMENT_SYSTEM_TYPE.METRIC ? ' cbm' : ' cbf'), readOnly: true, className: "pl-2 pr-2" },
                        { value: order.incoterms, className: "pl-2 pr-2"+(!isLoading && touched.orders && touched.orders[index]?.incoterms ? touched.orders && touched.orders[index]?.incoterms == 1 ? " bg-success" : " bg-danger"  : ""),hint: touched.orders && touched.orders[index]?.incoterms != 1 ? touched.orders[index]?.incoterms : ""},
                        { value: order.houseBillNo, className: "pl-2 pr-2"+(!isLoading && touched.orders && touched.orders[index]?.houseBillNo ? touched.orders && touched.orders[index]?.houseBillNo == 1 ? " bg-success" : " bg-danger"  : "")},
                        { value: order.totalWeight, className: "pl-2 pr-2" +(!isLoading && touched.orders && touched.orders[index]?.totalWeight ? touched.orders && touched.orders[index]?.totalWeight == 1? " bg-success" : " bg-danger" :  ""),hint: touched.orders && touched.orders[index]?.totalWeight != 1 ? touched.orders[index]?.totalWeight : ""},
                        { value: order.totalVolume,  className: "pl-2 pr-2"+(!isLoading && touched.orders && touched.orders[index]?.totalVolume ? touched.orders && touched.orders[index]?.totalVolume == 1? " bg-success" : " bg-danger" :  ""),hint: touched.orders && touched.orders[index]?.totalVolume != 1 ? touched.orders[index]?.totalVolume : ""},
                        { value: order.totalPackageType, className: "pl-2 pr-2" +(!isLoading && touched.orders && touched.orders[index]?.totalPackageType ? touched.orders && touched.orders[index]?.totalPackageType == 1? " bg-success" : " bg-danger" :  ""),hint: touched.orders && touched.orders[index]?.totalPackageType != 1 ? touched.orders[index]?.totalPackageType : ""},
                        { value: order.totalPackages,  className: "pl-2 pr-2"+(!isLoading && touched.orders && touched.orders[index]?.totalPackages ? touched.orders && touched.orders[index]?.totalPackages == 1? " bg-success" : " bg-danger" :  ""),hint: touched.orders && touched.orders[index]?.totalPackages != 1 ? touched.orders[index]?.totalPackages : ""},
                        { value: order.isPickup ? 'Y' : 'N', 
                          className: "pl-2 pr-2"+(!isLoading && touched.orders && touched.orders[index]?.isPickup ? touched.orders && touched.orders[index]?.isPickup == 1 ? " bg-success" : " bg-danger"  : ""),
                          hint: touched.orders && touched.orders[index]?.isPickup != 1 ? touched.orders[index]?.isPickup : ""
                        },
                        { value: order.originDropOffOn ? moment(order.originDropOffOn).format('YYYY-MM-DD') : '',  className: "pl-2 pr-2"+(!isLoading && touched.orders && touched.orders[index]?.originDropOffOn ? touched.orders && touched.orders[index]?.originDropOffOn == 1? " bg-success" : " bg-danger" :  ""),hint: touched.orders && touched.orders[index]?.originDropOffOn != 1 ? touched.orders[index]?.originDropOffOn : ""},
                        { value: order.note, className: "pl-2 pr-2"+(!isLoading && touched.orders && touched.orders[index]?.note ? touched.orders && touched.orders[index]?.note == 1 ? " bg-success" : " bg-danger"  : "")},
                      ]})).concat(summaryRows)}
                    overflow="wrap"
                    valueRenderer={cell => cell.value}
                    attributesRenderer={(cell) => {
                      const obj = Object.create({});
                      if (cell.hint) obj['data-hint'] = cell.hint;
                      return obj;
                    }}
                    onCellsChanged={changes => {
                      changes.forEach(({ cell, row, col, value }) => {
                        if (row <= 0 || row > filteredOrders.length + 1) return; // +1 for header
                        const displayIndex = row - 1;
                        if (displayIndex >= visibleOrderIndices.length) return;
                        const index = visibleOrderIndices[displayIndex];
                        
                        if (row > 0) {
                          setFieldValue(`orders.${index}.needsUpdate`,true);
                          // Column numbers shifted by 1 due to new Business Entity column
                          if (col == 7) {
                            setFieldValue(`orders.${index}.incoterms`, value);
                            if (value && value.trim() !== '') {
                              const upperValue = value.toUpperCase();
                              setFieldValue(`orders.${index}.incoterms`, upperValue);
                              if (!Object.values(INCOTERMS).includes(upperValue)) {
                                setFieldTouched(`orders.${index}.incoterms`, 
                                  intl.formatMessage({ id: "VALIDATION_INCOTERMS" }));
                              } else {
                                setFieldTouched(`orders.${index}.incoterms`, 1);
                              }
                            } else {
                              setFieldTouched(`orders.${index}.incoterms`, 1);
                            }
                          }
                          if (col == 8) {
                            setFieldValue(`orders.${index}.houseBillNo`,value);
                            setFieldTouched(`orders.${index}.houseBillNo`);
                          }
                          if (col == 9) {
                            setFieldValue(`orders.${index}.totalWeight`,value);
                            if (value && value.trim() !== '') {
                              if (isNaN(value)) {
                                setFieldTouched(`orders.${index}.totalWeight`,intl.formatMessage({ id: "VALIDATION_NUMBER"}));
                              } else {
                                setFieldTouched(`orders.${index}.totalWeight`,1);
                              }
                            } else {
                              setFieldTouched(`orders.${index}.totalWeight`,1);
                            }
                          }
                          if (col == 10) {
                            setFieldValue(`orders.${index}.totalVolume`,value);
                            if (value && value.trim() !== '') {
                              if (isNaN(value)) {
                                setFieldTouched(`orders.${index}.totalVolume`,intl.formatMessage({ id: "VALIDATION_NUMBER"}));
                              } else {
                                setFieldTouched(`orders.${index}.totalVolume`,1);
                              }
                            } else {
                              setFieldTouched(`orders.${index}.totalVolume`,1);
                            }
                          }
                          if (col == 11) {
                            setFieldValue(`orders.${index}.totalPackageType`, value);
                            if (value && value.trim() !== '') {
                              const upperValue = value.toUpperCase();
                              setFieldValue(`orders.${index}.totalPackageType`, upperValue);
                              if (!Object.values(PACKAGE_TYPE).includes(upperValue)) {
                                setFieldTouched(`orders.${index}.totalPackageType`, 
                                  intl.formatMessage({ id: "VALIDATION_PACKAGE_TYPE" }));
                              } else {
                                setFieldTouched(`orders.${index}.totalPackageType`, 1);
                              }
                            } else {
                              setFieldTouched(`orders.${index}.totalPackageType`, 1);
                            }
                          }
                          if (col == 12) {
                            setFieldValue(`orders.${index}.totalPackages`, value);
                            if (value && value.toString().trim() !== '') {
                              if (isNaN(value)) {
                                setFieldTouched(`orders.${index}.totalPackages`, 
                                  intl.formatMessage({ id: "VALIDATION_NUMBER"}));
                              } else {
                                setFieldTouched(`orders.${index}.totalPackages`, 1);
                              }
                            } else {
                              setFieldTouched(`orders.${index}.totalPackages`, 1);
                            }
                          }
                          if (col == 13) {
                            const upperValue = value.toUpperCase();
                            if (upperValue === 'Y' || upperValue === 'YES' || upperValue === 'TRUE' || upperValue === '1') {
                              setFieldValue(`orders.${index}.isPickup`, true);
                              setFieldTouched(`orders.${index}.isPickup`, 1);
                            } else if (upperValue === 'N' || upperValue === 'NO' || upperValue === 'FALSE' || upperValue === '0' || upperValue === '') {
                              setFieldValue(`orders.${index}.isPickup`, false);
                              setFieldTouched(`orders.${index}.isPickup`, 1);
                            } else {
                              setFieldTouched(`orders.${index}.isPickup`, intl.formatMessage({ id: "VALIDATION_YES_NO" }));
                            }
                          }
                          if (col == 14) {
                            const dateValue = value && value.trim() !== '' ? value : null;
                            setFieldValue(`orders.${index}.originDropOffOn`, dateValue);
                            
                            if (dateValue) {
                              if (!isValidDate(dateValue)) {
                                setFieldTouched(`orders.${index}.originDropOffOn`, 
                                  intl.formatMessage({ id: "VALIDATION_DATE" }));
                              } else {
                                setFieldTouched(`orders.${index}.originDropOffOn`, 1);
                              }
                            } else {
                              setFieldTouched(`orders.${index}.originDropOffOn`, 1);
                            }
                          }
                          if (col == 15) {
                            setFieldValue(`orders.${index}.note`,value);
                            setFieldTouched(`orders.${index}.note`);
                          }
                        }
                        validateForm();
                      });
                    }}
                  />
                </Col>
              </Row>
            </Form>
          </>
        )
        }
          }
      </Formik>




                
                <br/>
          </Col>
        </Row>
</>
      }
      {tabValue === 2 &&
        <>
          <Row className='mt-8'>
            <Col className="d-flex align-items-center flex-wrap">
              <Form.Group controlId="statusExtras">
                <Form.Control as="select" value={statusFilter} onChange={e => {
                  setStatusFilter(e.target.value);
                }}>
                  <option value=''> {intl.formatMessage({ id: "ALL_ACTIVE_ORDER" })}</option>
                  <option value={CONSOL_STATUS.DRAFT}>{cf.format('ConsolStatus', CONSOL_STATUS.DRAFT, intl.locale)}</option>
                  <option value={CONSOL_STATUS.SUBMITTED}>{cf.format('ConsolStatus', CONSOL_STATUS.SUBMITTED, intl.locale)}</option>
                  <option value={CONSOL_STATUS.CONFIRMED}>{cf.format('ConsolStatus', CONSOL_STATUS.CONFIRMED, intl.locale)}</option>
                  <option value={CONSOL_STATUS.RECEIVED}>{cf.format('ConsolStatus', CONSOL_STATUS.RECEIVED, intl.locale)}</option>
                  <option value={CONSOL_STATUS.AWAITING_SHIPMENT}>{cf.format('ConsolStatus', CONSOL_STATUS.AWAITING_SHIPMENT, intl.locale)}</option>
                  <option value={CONSOL_STATUS.SHIPPED}>{cf.format('ConsolStatus', CONSOL_STATUS.SHIPPED, intl.locale)}</option>
                  <option value={CONSOL_STATUS.DELIVERED}>{cf.format('ConsolStatus', CONSOL_STATUS.DELIVERED, intl.locale)}</option>
                  <option value={CONSOL_STATUS.CANCELLED}>{cf.format('ConsolStatus', CONSOL_STATUS.CANCELLED, intl.locale)}</option>
                </Form.Control>
                <Form.Text className="text-muted">
                  <b>{intl.formatMessage({ id: "FILTER" })}</b>{" "}
                  {intl.formatMessage({ id: "STATUS" })}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          
          {/* SINGLE FORMIK WRAPPER FOR BOTH TABLES */}
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validateOnChange={true}
            onSubmit={(values, { touched, setSubmitting }) => {
              var createObservable = [];
              var updateObservable = [];
              
              // Process orders that have changes in either table
              values.orders.filter(o => o.needsUpdateExtras).forEach((order) => {
                const extras = order.consolExtraTemp || {};
                
                const isExisting = order.consolExtraTemp && order.consolExtraTemp.consolId;
                
                const extraData = {
                  consolId: order.id,
                  quotedVolume: extras.quotedVolume ?? null,
                  quotedRate: extras.quotedRate ?? null,
                  quotedRateCurrency: extras.quotedRateCurrency ?? null,
                  trukingCost: extras.trukingCost ?? null,
                  truckingCostCurrency: extras.truckingCostCurrency ?? null,
                  truckingRevenue: extras.truckingRevenue ?? null,
                  truckingRevenueCurrency: extras.truckingRevenueCurrency ?? null,
                  customsCost: extras.customsCost ?? null,
                  customsCostCurrency: extras.customsCostCurrency ?? null,
                  customsRevenue: extras.customsRevenue ?? null,
                  customsRevenueCurrency: extras.customsRevenueCurrency ?? null,
                  _3plcost: extras._3plcost ?? null,
                  _3plcostCurrency: extras._3plcostCurrency ?? null,
                  crossDockingCost: extras.crossDockingCost ?? null,
                  crossDockingCostCurrency: extras.crossDockingCostCurrency ?? null,
                  fsvpps: extras.fsvpps ?? null,
                  fsvppscurrency: extras.fsvppscurrency ?? null,
                  memo: extras.memo ?? null,
                  fdaFilingFee: extras.fdaFilingFee ?? null,
                  fdaFilingFeeCurrency: extras.fdaFilingFeeCurrency ?? null,
                  fdaPriorNoticeFee: extras.fdaPriorNoticeFee ?? null,
                  fdaPriorNoticeFeeCurrency: extras.fdaPriorNoticeFeeCurrency ?? null,
                  ddp: extras.ddp ?? null,
                  ddPcurrency: extras.ddPcurrency ?? null,
                  singleBond: extras.singleBond ?? null,
                  singleBondCurrency: extras.singleBondCurrency ?? null,
                  insurance: extras.insurance ?? null,
                  insuranceCurrency: extras.insuranceCurrency ?? null,
                  isftAbenefit: extras.isftAbenefit,
                  isfdAconfirmed: extras.isfdAconfirmed,
                  fdAmemo: extras.fdAmemo ?? null
                };
                
                if (isExisting) {
                  updateObservable.push(flitSvc.updateConsolExtra(extraData));
                } else {
                  createObservable.push(flitSvc.createConsolExtra(extraData));
                }
              });
              
              const allObservables = [...createObservable, ...updateObservable];
              
              if (allObservables.length > 0) {
                forkJoin(allObservables).subscribe(res => {
                  setSubmitting(false);
                  refresh();
                }, err => {
                  setSubmitting(false);
                  console.error('Error saving consol extras:', err);
                });
              } else {
                setSubmitting(false);
              }
            }}
          >
            {({
              values,
              touched,
              handleSubmit,
              setFieldValue,
              setFieldTouched,
              isSubmitting,
              validateForm,
            }) => {
              const getSortedAndFilteredOrders = (orders) => {
                return stableSort(orders, getSorting(order, orderBy))
                  .filter(order => 
                    !statusFilter 
                      ? order.status !== CONSOL_STATUS.CANCELLED 
                      : order.status === statusFilter
                  );
              };

              const filteredOrders = getSortedAndFilteredOrders(values.orders);
              
              const visibleOrderIndices = stableSort(values.orders, getSorting(order, orderBy))
              .map((order, index) => {
                const shouldShow = !statusFilter 
                  ? order.status !== CONSOL_STATUS.CANCELLED 
                  : order.status === statusFilter;
                return shouldShow ? values.orders.findIndex(o => o.id === order.id) : null;
              })
              .filter(index => index !== null);

              return (
                <Form
                  onSubmit={handleSubmit}
                  noValidate
                  autoComplete="off"
                  className="form form-label-right"
                >
                  {/* SINGLE SAVE BUTTON FOR BOTH TABLES */}
                  <Row className="mb-2">
                    <Col>
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {intl.formatMessage({ id: "EXTRA_FIELDS_HINT" })}
                        </div>
                      </div>
                    </Col>
                    <Col>
                      <button
                        type='submit'
                        disabled={
                          isSubmitting || 
                          isLoading || 
                          !(touched.orders && touched.orders.some(t => 
                            t && t.consolExtraTemp && Object.keys(t.consolExtraTemp).length > 0
                          )) ||
                          (touched.orders && touched.orders.some(t => 
                            t && t.consolExtraTemp && Object.keys(t.consolExtraTemp).some(key => 
                              t.consolExtraTemp[key] !== 1
                            )
                          ))
                        }
                        className={`btn btn-warning btn-elevate float-right kt-login__btn-primary`}
                      >
                        {intl.formatMessage({ id: "SAVE_CHANGES" })}
                        {isSubmitting && <span className="ml-3 mr-5 spinner spinner-white"></span>}
                      </button>
                    </Col>
                  </Row>

                  {/* FIRST TABLE - Original Extra Fields */}
                  <Row className="mt-4">
                    <Col>
                      <ReactDataSheet
                        data={[[
                          {value: intl.formatMessage({ id: "ORDER_ID" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "STATUS" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "BUSINESS_ENTITY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "QUOTED_VOLUME" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "QUOTED_RATE" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "QUOTED_RATE_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "TRUCKING_COST" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "TRUCKING_COST_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "TRUCKING_REVENUE" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "TRUCKING_REVENUE_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "CUSTOMS_COST" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "CUSTOMS_COST_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "CUSTOMS_REVENUE" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "CUSTOMS_REVENUE_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "3PL_COST" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "3PL_COST_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "CROSS_DOCKING_COST" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "CROSS_DOCKING_COST_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "FSVPPS" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "FSVPPS_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "MEMO" }), readOnly: true, className: "pl-2 pr-2"}
                          ]].concat(filteredOrders.map((order, displayIndex) => {
                            const index = visibleOrderIndices[displayIndex];
                            const extras = order.consolExtraTemp || {};
                            
                            return [
                              {value: "FLIT-C-" + order.id, readOnly: true, className: "pl-2 pr-2"},
                              {value: cf.format('ConsolStatus', order.status, intl.locale), readOnly: true, className: "pl-2 pr-2"},
                              {value: order.activity.quoteRequest[0]?.submittedBy.businessEntity?.legalName, readOnly: true, className: "pl-2 pr-2"},
                              {
                                value: extras.quotedVolume || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.quotedVolume ? 
                                  (touched.orders[index].consolExtraTemp.quotedVolume === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.quotedVolume !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.quotedVolume === 'string' ? 
                                  touched.orders[index].consolExtraTemp.quotedVolume : ""
                              },
                              {
                                value: formatCurrencyAmount(extras.quotedRate), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.quotedRate ? 
                                  (touched.orders[index].consolExtraTemp.quotedRate === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.quotedRate !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.quotedRate === 'string' ? 
                                  touched.orders[index].consolExtraTemp.quotedRate : ""
                              },
                              {
                                value: extras.quotedRateCurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.quotedRateCurrency ? 
                                  (touched.orders[index].consolExtraTemp.quotedRateCurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.quotedRateCurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.quotedRateCurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp.quotedRateCurrency : ""
                              },
                              {
                                value: formatCurrencyAmount(extras.trukingCost), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.trukingCost !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.trukingCost === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.trukingCost !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.trukingCost === 'string' ? 
                                  touched.orders[index].consolExtraTemp.trukingCost : ""
                              },
                              {
                                value: extras.truckingCostCurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.truckingCostCurrency !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.truckingCostCurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.truckingCostCurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.truckingCostCurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp.truckingCostCurrency : ""
                              },
                              {
                                value: formatCurrencyAmount(extras.truckingRevenue), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.truckingRevenue !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.truckingRevenue === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.truckingRevenue !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.truckingRevenue === 'string' ? 
                                  touched.orders[index].consolExtraTemp.truckingRevenue : ""
                              },
                              {
                                value: extras.truckingRevenueCurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.truckingRevenueCurrency !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.truckingRevenueCurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.truckingRevenueCurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.truckingRevenueCurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp.truckingRevenueCurrency : ""
                              },
                              {
                                value: formatCurrencyAmount(extras.customsCost), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.customsCost !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.customsCost === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.customsCost !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.customsCost === 'string' ? 
                                  touched.orders[index].consolExtraTemp.customsCost : ""
                              },
                              {
                                value: extras.customsCostCurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.customsCostCurrency !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.customsCostCurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.customsCostCurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.customsCostCurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp.customsCostCurrency : ""
                              },
                              {
                                value: formatCurrencyAmount(extras.customsRevenue), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.customsRevenue !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.customsRevenue === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.customsRevenue !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.customsRevenue === 'string' ? 
                                  touched.orders[index].consolExtraTemp.customsRevenue : ""
                              },
                              {
                                value: extras.customsRevenueCurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.customsRevenueCurrency !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.customsRevenueCurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.customsRevenueCurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.customsRevenueCurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp.customsRevenueCurrency : ""
                              },
                              {
                                value: formatCurrencyAmount(extras._3plcost), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?._3plcost !== undefined ? 
                                  (touched.orders[index].consolExtraTemp._3plcost === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?._3plcost !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?._3plcost === 'string' ? 
                                  touched.orders[index].consolExtraTemp._3plcost : ""
                              },
                              {
                                value: extras._3plcostCurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?._3plcostCurrency !== undefined ? 
                                  (touched.orders[index].consolExtraTemp._3plcostCurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?._3plcostCurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?._3plcostCurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp._3plcostCurrency : ""
                              },
                              {
                                value: formatCurrencyAmount(extras.crossDockingCost), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.crossDockingCost !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.crossDockingCost === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.crossDockingCost !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.crossDockingCost === 'string' ? 
                                  touched.orders[index].consolExtraTemp.crossDockingCost : ""
                              },
                              {
                                value: extras.crossDockingCostCurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.crossDockingCostCurrency !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.crossDockingCostCurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.crossDockingCostCurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.crossDockingCostCurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp.crossDockingCostCurrency : ""
                              },
                              {
                                value: formatCurrencyAmount(extras.fsvpps), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.fsvpps !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.fsvpps === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.fsvpps !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.fsvpps === 'string' ? 
                                  touched.orders[index].consolExtraTemp.fsvpps : ""
                              },
                              {
                                value: extras.fsvppscurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.fsvppscurrency !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.fsvppscurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.fsvppscurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.fsvppscurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp.fsvppscurrency : ""
                              },
                              {
                                value: extras.memo || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.memo !== undefined && touched.orders[index].consolExtraTemp.memo !== null ? " bg-success" : "")
                              }
                            ];
                          }))}
                        overflow="wrap"
                        valueRenderer={cell => cell.value}
                        attributesRenderer={(cell) => {
                          const obj = Object.create({});
                          if (cell.hint) obj['data-hint'] = cell.hint;
                          return obj;
                        }}
                        onCellsChanged={changes => {
                          changes.forEach(({ cell, row, col, value }) => {
                            if (row <= 0 || row > filteredOrders.length) return;
                            const displayIndex = row - 1;
                            if (displayIndex >= visibleOrderIndices.length) return;
                            const index = visibleOrderIndices[displayIndex];
                            
                            setFieldValue(`orders.${index}.needsUpdateExtras`, true);
                            
                            if (!values.orders[index].consolExtraTemp) {
                              setFieldValue(`orders.${index}.consolExtraTemp`, {});
                            }
                            
                            const cleanValue = [3, 4, 6, 8, 10, 12, 14, 16, 18].includes(col)
                              ? parseFormattedNumber(value)
                              : value;
                            
                            const fieldMap = {
                              3: { name: 'quotedVolume', type: 'number' },
                              4: { name: 'quotedRate', type: 'number' },
                              5: { name: 'quotedRateCurrency', type: 'currency' },
                              6: { name: 'trukingCost', type: 'number' },
                              7: { name: 'truckingCostCurrency', type: 'currency' },
                              8: { name: 'truckingRevenue', type: 'number' },
                              9: { name: 'truckingRevenueCurrency', type: 'currency' },
                              10: { name: 'customsCost', type: 'number' },
                              11: { name: 'customsCostCurrency', type: 'currency' },
                              12: { name: 'customsRevenue', type: 'number' },
                              13: { name: 'customsRevenueCurrency', type: 'currency' },
                              14: { name: '_3plcost', type: 'number' },
                              15: { name: '_3plcostCurrency', type: 'currency' },
                              16: { name: 'crossDockingCost', type: 'number' },
                              17: { name: 'crossDockingCostCurrency', type: 'currency' },
                              18: { name: 'fsvpps', type: 'number' },
                              19: { name: 'fsvppscurrency', type: 'currency' },
                              20: { name: 'memo', type: 'text' }
                            };
                            
                            const field = fieldMap[col];
                            if (field) {
                              setFieldValue(`orders.${index}.consolExtraTemp.${field.name}`, cleanValue);
                              
                              if (field.type === 'number') {
                                if (cleanValue && cleanValue.trim() !== '') {
                                  if (isNaN(cleanValue)) {
                                    setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 
                                      intl.formatMessage({ id: "VALIDATION_NUMBER"}));
                                  } else {
                                    setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                                  }
                                } else {
                                  setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                                }
                              } else if (field.type === 'currency') {
                                if (cleanValue && cleanValue.trim() !== '') {
                                  const upperValue = cleanValue.toUpperCase();
                                  setFieldValue(`orders.${index}.consolExtraTemp.${field.name}`, upperValue);
                                  if (!VALID_CURRENCIES.includes(upperValue)) {
                                    setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 
                                      intl.formatMessage({ id: "VALIDATION_CURRENCY" }));
                                  } else {
                                    setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                                  }
                                } else {
                                  setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                                }
                              } else if (field.type === 'text') {
                                setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                              }
                            }
                          });
                          validateForm();
                        }}
                      />
                    </Col>
                  </Row>

                  {/* SECOND TABLE - Additional FDA/Bond/Insurance Fields */}
                  <Row className="mt-8">
                    <Col>
                      <ReactDataSheet
                        data={[[
                          {value: intl.formatMessage({ id: "ORDER_ID" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "STATUS" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "BUSINESS_ENTITY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "FDA_FILING_FEE" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "FDA_FILING_FEE_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "FDA_PRIOR_NOTICE_FEE" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "FDA_PRIOR_NOTICE_FEE_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "DDP" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "DDP_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "SINGLE_BOND" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "SINGLE_BOND_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "INSURANCE" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "INSURANCE_CURRENCY" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "IS_FTA_BENEFIT" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "IS_FDA_CONFIRMED" }), readOnly: true, className: "pl-2 pr-2"},
                          {value: intl.formatMessage({ id: "FDA_MEMO" }), readOnly: true, className: "pl-2 pr-2"}
                          ]].concat(filteredOrders.map((order, displayIndex) => {
                            const index = visibleOrderIndices[displayIndex];
                            const extras = order.consolExtraTemp || {};
                            
                            return [
                              {value: "FLIT-C-" + order.id, readOnly: true, className: "pl-2 pr-2"},
                              {value: cf.format('ConsolStatus', order.status, intl.locale), readOnly: true, className: "pl-2 pr-2"},
                              {value: order.activity.quoteRequest[0]?.submittedBy.businessEntity?.legalName, readOnly: true, className: "pl-2 pr-2"},
                              {
                                value: formatCurrencyAmount(extras.fdaFilingFee), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.fdaFilingFee !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.fdaFilingFee === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.fdaFilingFee !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.fdaFilingFee === 'string' ? 
                                  touched.orders[index].consolExtraTemp.fdaFilingFee : ""
                              },
                              {
                                value: extras.fdaFilingFeeCurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.fdaFilingFeeCurrency !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.fdaFilingFeeCurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.fdaFilingFeeCurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.fdaFilingFeeCurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp.fdaFilingFeeCurrency : ""
                              },
                              {
                                value: formatCurrencyAmount(extras.fdaPriorNoticeFee), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.fdaPriorNoticeFee !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.fdaPriorNoticeFee === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.fdaPriorNoticeFee !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.fdaPriorNoticeFee === 'string' ? 
                                  touched.orders[index].consolExtraTemp.fdaPriorNoticeFee : ""
                              },
                              {
                                value: extras.fdaPriorNoticeFeeCurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.fdaPriorNoticeFeeCurrency !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.fdaPriorNoticeFeeCurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.fdaPriorNoticeFeeCurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.fdaPriorNoticeFeeCurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp.fdaPriorNoticeFeeCurrency : ""
                              },
                              {
                                value: formatCurrencyAmount(extras.ddp), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.ddp !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.ddp === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.ddp !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.ddp === 'string' ? 
                                  touched.orders[index].consolExtraTemp.ddp : ""
                              },
                              {
                                value: extras.ddPcurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.ddPcurrency !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.ddPcurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.ddPcurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.ddPcurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp.ddPcurrency : ""
                              },
                              {
                                value: formatCurrencyAmount(extras.singleBond), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.singleBond !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.singleBond === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.singleBond !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.singleBond === 'string' ? 
                                  touched.orders[index].consolExtraTemp.singleBond : ""
                              },
                              {
                                value: extras.singleBondCurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.singleBondCurrency !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.singleBondCurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.singleBondCurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.singleBondCurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp.singleBondCurrency : ""
                              },
                              {
                                value: formatCurrencyAmount(extras.insurance), 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.insurance !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.insurance === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.insurance !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.insurance === 'string' ? 
                                  touched.orders[index].consolExtraTemp.insurance : ""
                              },
                              {
                                value: extras.insuranceCurrency || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.insuranceCurrency !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.insuranceCurrency === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.insuranceCurrency !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.insuranceCurrency === 'string' ? 
                                  touched.orders[index].consolExtraTemp.insuranceCurrency : ""
                              },
                              {
                                value: extras.isftAbenefit == true ? 'Y' : extras.isftAbenefit == false ? 'N' : null,
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.isftAbenefit !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.isftAbenefit === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.isftAbenefit !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.isftAbenefit === 'string' ? 
                                  touched.orders[index].consolExtraTemp.isftAbenefit : ""
                              },
                              {
                                value: extras.isfdAconfirmed == true ? 'Y' : extras.isfdAconfirmed == false ? 'N' : null,
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.isfdAconfirmed !== undefined ? 
                                  (touched.orders[index].consolExtraTemp.isfdAconfirmed === 1 ? " bg-success" : " bg-danger") : ""),
                                hint: touched.orders?.[index]?.consolExtraTemp?.isfdAconfirmed !== 1 && typeof touched.orders?.[index]?.consolExtraTemp?.isfdAconfirmed === 'string' ? 
                                  touched.orders[index].consolExtraTemp.isfdAconfirmed : ""
                              },
                              {
                                value: extras.fdAmemo || '', 
                                className: "pl-2 pr-2" + (!isLoading && touched.orders?.[index]?.consolExtraTemp?.fdAmemo !== undefined && touched.orders[index].consolExtraTemp.fdAmemo !== null ? " bg-success" : "")
                              }
                            ];
                          }))}
                        overflow="wrap"
                        valueRenderer={cell => cell.value}
                        attributesRenderer={(cell) => {
                          const obj = Object.create({});
                          if (cell.hint) obj['data-hint'] = cell.hint;
                          return obj;
                        }}
                        onCellsChanged={changes => {
                          changes.forEach(({ cell, row, col, value }) => {
                            if (row <= 0 || row > filteredOrders.length) return;
                            const displayIndex = row - 1;
                            if (displayIndex >= visibleOrderIndices.length) return;
                            const index = visibleOrderIndices[displayIndex];
                            
                            setFieldValue(`orders.${index}.needsUpdateExtras`, true);
                            
                            if (!values.orders[index].consolExtraTemp) {
                              setFieldValue(`orders.${index}.consolExtraTemp`, {});
                            }
                            
                            const cleanValue = [3, 5, 7, 9, 11].includes(col)
                              ? parseFormattedNumber(value)
                              : value;
                            
                            const fieldMap = {
                              3: { name: 'fdaFilingFee', type: 'number' },
                              4: { name: 'fdaFilingFeeCurrency', type: 'currency' },
                              5: { name: 'fdaPriorNoticeFee', type: 'number' },
                              6: { name: 'fdaPriorNoticeFeeCurrency', type: 'currency' },
                              7: { name: 'ddp', type: 'number' },
                              8: { name: 'ddPcurrency', type: 'currency' },
                              9: { name: 'singleBond', type: 'number' },
                              10: { name: 'singleBondCurrency', type: 'currency' },
                              11: { name: 'insurance', type: 'number' },
                              12: { name: 'insuranceCurrency', type: 'currency' },
                              13: { name: 'isftAbenefit', type: 'boolean' },
                              14: { name: 'isfdAconfirmed', type: 'boolean' },
                              15: { name: 'fdAmemo', type: 'text' }
                            };
                            
                            const field = fieldMap[col];
                            if (field) {
                              setFieldValue(`orders.${index}.consolExtraTemp.${field.name}`, cleanValue);
                              
                              if (field.type === 'number') {
                                if (cleanValue && cleanValue.trim() !== '') {
                                  if (isNaN(cleanValue)) {
                                    setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 
                                      intl.formatMessage({ id: "VALIDATION_NUMBER"}));
                                  } else {
                                    setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                                  }
                                } else {
                                  setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                                }
                              } else if (field.type === 'currency') {
                                if (cleanValue && cleanValue.trim() !== '') {
                                  const upperValue = cleanValue.toUpperCase();
                                  setFieldValue(`orders.${index}.consolExtraTemp.${field.name}`, upperValue);
                                  if (!VALID_CURRENCIES.includes(upperValue)) {
                                    setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 
                                      intl.formatMessage({ id: "VALIDATION_CURRENCY" }));
                                  } else {
                                    setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                                  }
                                } else {
                                  setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                                }
                              } else if (field.type === 'boolean') {
                                const upperValue = cleanValue.trim().toUpperCase();
                                if (upperValue === '') {
                                  // Empty string = null (not set)
                                  setFieldValue(`orders.${index}.consolExtraTemp.${field.name}`, null);
                                  setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                                } else if (upperValue === 'Y' || upperValue === 'YES' || upperValue === 'TRUE' || upperValue === '1') {
                                  setFieldValue(`orders.${index}.consolExtraTemp.${field.name}`, true);
                                  setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                                } else if (upperValue === 'N' || upperValue === 'NO' || upperValue === 'FALSE' || upperValue === '0') {
                                  setFieldValue(`orders.${index}.consolExtraTemp.${field.name}`, false);
                                  setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                                } else {
                                  setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 
                                    intl.formatMessage({ id: "VALIDATION_YES_NO" }));
                                }
                              } else if (field.type === 'text') {
                                setFieldTouched(`orders.${index}.consolExtraTemp.${field.name}`, 1);
                              }
                            }
                          });
                          validateForm();
                        }}
                      />
                    </Col>
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </>
      }
      </CardBody>
      {/*<ErrorDialog show={showErrorDialog} onHide={closeErrorDialog}/>*/}
    </Card>
    {invoiceList && invoiceList.length >0 && <ConsolScheduleInvoices invoiceList={invoiceList} history={history} refreshCallback={refresh}/>}

    </Col>

    </Row>
        
    <Modal
          size="lg"
          show={showShipmentReadyDialog}
          onHide={onHideShipmentReadyDialog}
          aria-labelledby="example-modal-sizes-title-lg"
          centered={true}
      >
        <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">{intl.formatMessage({ id: "CONSOL_STATUS_TO_SHIPMENT_READY" })}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    <Row>
                        <Col style={{"textAlign":"center"}}>
                        {intl.formatMessage({ id: "CONSOL_STATUS_TO_SHIPMENT_READY_WARNING_MESSAGE" })}
                        </Col>
                    </Row>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    onClick={() => setShowShipmentReadyDialog(false)}
                    className={`btn btn-light font-weight-bold px-9 py-4 my-3`}
                    disabled={isLoading}
                >
                    {intl.formatMessage({ id: "CANCEL_BUTTON" })}
                </button>

                <button
                    type="submit"
                    onClick={() => {

                      setIsLoading(true);
                      if(showShipmentReadyDialog == 'selected') {
                            var updateObservable = [];
                            selected.forEach((id) => {
                              updateObservable.push(flitSvc.updateConsolStatus(id,CONSOL_STATUS.AWAITING_SHIPMENT));
                            });
                            forkJoin(updateObservable).subscribe(res=> {
                              setShowShipmentReadyDialog(false);
                              refresh();
                            }, err => {
                              //
                            });
                      } else {
                        flitSvc.updateConsolStatus(showShipmentReadyDialog,CONSOL_STATUS.AWAITING_SHIPMENT).then(({ data }) => {
                          setShowShipmentReadyDialog(false);
                          refresh();
                        });
                      }
                    }}
                    className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
                    disabled={isLoading}
                >
                    {intl.formatMessage({ id: "SUBMIT_BUTTON" })}
                </button>
            </Modal.Footer>

      </Modal>
      <AvailableScheduleDialog show={showAvailableScheduleDialog} onHide={closeAvailableScheduleDialog}/>
      <Modal
          size="md"
          show={showDueInputDialog}
          onHide={onHideDueInputDialog}
          aria-labelledby="example-modal-sizes-title-lg"
          centered={true}
      >
        <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">{intl.formatMessage({ id: "INPUT_INVOICE_DUE" })}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <Form.Group controlId="duoOn">
                            <Form.Label>{intl.formatMessage({ id: "DUE_ON" })}</Form.Label><br/>
                            <DatePicker name="cargoReadyOn" selected={dueOn} onChange={date => {
                                                        setDueOn(date)
                                                        //setFieldTouched('cargoReadyOn', true);
                                                    }}
                                                        className='form-control'/>
                        </Form.Group>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    onClick={() => setShowDueInputDialog(false)}
                    className={`btn btn-light font-weight-bold px-9 py-4 my-3`}
                    disabled={isLoading}
                >
                    {intl.formatMessage({ id: "CANCEL_BUTTON" })}
                </button>

                <button
                    type="submit"
                    onClick={() => {
                      setIsLoading(true);
                      if(showDueInputDialog == 'selected') {
                            var updateObservable = [];
                            selected.forEach((id) => {
                              updateObservable.push(flitSvc.consolDraftInvoice(id,dueOn));
                            });
                            forkJoin(updateObservable).subscribe(res=> {
                              setShowDueInputDialog(false);
                              refresh();
                            }, err => {
                              //
                            });
                      } else {
                        flitSvc.consolDraftInvoice(showDueInputDialog,dueOn).then(({ data }) => {
                          setShowDueInputDialog(false);
                          refresh();
                        });
                      }


                    }}
                    className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
                    disabled={isLoading}
                >
                    {intl.formatMessage({ id: "SUBMIT_BUTTON" })}
                </button>
            </Modal.Footer>

      </Modal>
      <FileInvoiceDialog show={showInvoiceDialog} onHide={handleCloseInvoiceDialog} consolId={invoiceConsolId}/>
      <NewConsolOrderDialog show={showNewConsolOrderDialog} onHide={handleCloseNewConsolOrderDialog} consolSchedule={consolSchedule} orderId={editingOrderId}/>
    </>
  )
}


export default injectIntl(ConsolScheduleOrders);